'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Styles = require('../utils/Styles');

var _NormalColors = require('../core/NormalColors');

var _NormalColors2 = _interopRequireDefault(_NormalColors);

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BADGE_COLORS = {
  beta: _colors.THUNDERDOME,
  default: _colors.LORAX,
  free: _colors.LORAX,
  new: _colors.OZ,
  none: null
};

var COUNT_BADGES = { count: null, dot: null };

var BADGE_USES = _extends({}, _NormalColors2.default, BADGE_COLORS, COUNT_BADGES);

var NOTIFICATION_BADGE_BORDER_WIDTH = '1px';
var NOTIFICATION_BADGE_DEFAULT_SIZE = '21px';
var NOTIFICATION_BADGE_FONT_SIZE = '11px';
var NOTIFICATION_BADGE_SMALL_SIZE = '10px';

var COMPUTED_LINE_HEIGHT = (0, _Styles.toPx)(parseInt(NOTIFICATION_BADGE_DEFAULT_SIZE, 10) - parseInt(NOTIFICATION_BADGE_BORDER_WIDTH, 10) * 2);

var StyledBadge = _styledComponents2.default.span.attrs({
  className: function className(props) {
    return (0, _classNames2.default)('private-badge', props.className);
  }
}).withConfig({
  displayName: 'UIBadge__StyledBadge'
})(['', ';font-size:', ';', ';', ';background-color:', ';color:', ';display:inline-block;line-height:', ';min-height:', ';padding:0 8px;text-align:center;text-transform:uppercase;vertical-align:inherit;'], _Styles.FONT_FAMILIES.bold, _sizes.BADGE_ROUNDED_FONT_SIZE, (0, _Styles.setFontSmoothing)('antialiased'), (0, _Styles.setBorderRadius)(), function (props) {
  return BADGE_USES[props.use];
}, _colors.OLAF, _sizes.BADGE_ROUNDED_HEIGHT, _sizes.BADGE_ROUNDED_HEIGHT);

var countStyles = '\n  ' + _Styles.FONT_FAMILIES.demibold() + ';\n  font-size: ' + NOTIFICATION_BADGE_FONT_SIZE + ';\n  ' + (0, _Styles.setFontSmoothing)('antialiased') + ';\n  border-radius: 500px;\n  color: ' + _colors.OLAF + ';\n  line-height: ' + COMPUTED_LINE_HEIGHT + ';\n  min-height: ' + NOTIFICATION_BADGE_DEFAULT_SIZE + ';\n  min-width: ' + NOTIFICATION_BADGE_DEFAULT_SIZE + ';\n  padding: 0 4px;\n';

var dotStyles = '\n  border-radius: 100%;\n  height: ' + NOTIFICATION_BADGE_SMALL_SIZE + ';\n  text-indent: -1000rem;\n  width: ' + NOTIFICATION_BADGE_SMALL_SIZE + ';\n';

var CountBadge = _styledComponents2.default.span.attrs({
  className: function className(props) {
    return (0, _classNames2.default)(props.className, {
      'private-badge--count': props.use === 'count',
      'private-badge--dot': props.use === 'dot'
    });
  }
}).withConfig({
  displayName: 'UIBadge__CountBadge'
})(['background-color:', ';border:', ' solid ', ';box-shadow:0 0 0 ', ' ', ';display:inline-block;pointer-events:none;text-align:center;vertical-align:baseline;', ';', ';'], _colors.NORMAN, NOTIFICATION_BADGE_BORDER_WIDTH, _colors.OLAF, NOTIFICATION_BADGE_BORDER_WIDTH, _colors.OLAF, function (props) {
  return props.use === 'count' ? countStyles : null;
}, function (props) {
  return props.use === 'dot' ? dotStyles : null;
});

var UIBadge = function UIBadge(props) {
  var children = props.children,
      className = props.className,
      use = props.use,
      rest = _objectWithoutProperties(props, ['children', 'className', 'use']);

  var RenderedBadge = !(use === 'count' || use === 'dot') ? StyledBadge : CountBadge;

  return _react2.default.createElement(
    RenderedBadge,
    _extends({}, rest, { className: className, use: use }),
    children
  );
};

UIBadge.propTypes = {
  children: _react.PropTypes.node.isRequired,
  use: _react.PropTypes.oneOf(Object.keys(BADGE_USES))
};

UIBadge.defaultProps = {
  use: 'free'
};

UIBadge.displayName = 'UIBadge';

exports.default = UIBadge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/badge/UIBadge.js
// module id = 169
// module chunks = 3 4 5